(() => {
  // cart-drawer and main-cart both render bundle-cart-assets, so this file may load twice.
  // Guard against double-initialisation.
  if (window.__bundleCartGuardLoaded) return;
  window.__bundleCartGuardLoaded = true;

  const REMOVE_LABEL = '移除整組';
  const GROUP_TITLE = '組合優惠';
  const TAMPER_MESSAGE = '組合商品數量已變更，已移除整組，請重新選購';

  // Remove all line items sharing the same _bundle_id
  async function removeBundleGroup(bundleId) {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const updates = {};
    cart.items.forEach((item) => {
      if (item.properties?._bundle_id === bundleId) updates[item.key] = 0;
    });
    if (Object.keys(updates).length === 0) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    // On the cart page the table isn't re-rendered by cart:refresh (theme reloads the
    // page for native quantity changes), so reload to avoid stale rows. The drawer
    // re-renders on cart:refresh.
    if (window.themeVariables?.settings?.pageType === 'cart') {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  // Inject a group header (title + remove-all button) before the first line item of each bundle group.
  // Cart drawer (<line-item>) and cart page table (<tr>) coexist in the DOM, so we dedupe
  // per-selector (each container gets its own header) rather than globally.
  function injectGroupHeaders(root) {
    injectForSelector(root, 'line-item[data-bundle-id]', false);
    injectForSelector(root, 'tr[data-bundle-id]', true);
  }

  function injectForSelector(root, selector, isTableRow) {
    const seen = new Set();
    root.querySelectorAll(selector).forEach((el) => {
      const bundleId = el.getAttribute('data-bundle-id');
      if (seen.has(bundleId)) return;
      seen.add(bundleId);

      // Avoid duplicate injection on re-render
      const prev = el.previousElementSibling;
      if (prev?.classList?.contains('bundle-group-header') || prev?.classList?.contains('bundle-group-header-row')) {
        return;
      }

      const headerInner = `
        <span class="bundle-group-header__title h6">${GROUP_TITLE}</span>
        <button type="button" class="bundle-group-header__remove link text-xs">${REMOVE_LABEL}</button>
      `;

      let header;
      if (isTableRow) {
        header = document.createElement('tr');
        header.className = 'bundle-group-header-row';
        header.dataset.bundleId = bundleId;
        const colspan = el.children.length || 3;
        header.innerHTML = `<td colspan="${colspan}"><div class="bundle-group-header">${headerInner}</div></td>`;
      } else {
        header = document.createElement('div');
        header.className = 'bundle-group-header';
        header.dataset.bundleId = bundleId;
        header.innerHTML = headerInner;
      }

      header.querySelector('.bundle-group-header__remove').addEventListener('click', () => {
        removeBundleGroup(bundleId);
      });
      el.parentNode.insertBefore(header, el);
    });
  }

  // Tamper protection: if any group's total quantity != _bundle_required, remove the whole group
  async function guardTampering(cart) {
    const groups = {};
    cart.items.forEach((item) => {
      const id = item.properties?._bundle_id;
      if (!id) return;
      if (!groups[id]) groups[id] = { total: 0, required: parseInt(item.properties._bundle_required, 10) };
      groups[id].total += item.quantity;
    });

    for (const [id, g] of Object.entries(groups)) {
      if (Number.isFinite(g.required) && g.total !== g.required) {
        await removeBundleGroup(id);
        showTamperNotice();
        break; // cart:refresh will re-trigger; avoid parallel removals
      }
    }
  }

  function showTamperNotice() {
    let notice = document.querySelector('.bundle-tamper-notice');
    if (notice) return;
    notice = document.createElement('div');
    notice.className = 'bundle-tamper-notice banner banner--error';
    notice.setAttribute('role', 'alert');
    notice.textContent = TAMPER_MESSAGE;
    document.body.appendChild(notice);
    setTimeout(() => notice.remove(), 5000);
  }

  function runInjection() {
    injectGroupHeaders(document);
  }

  // Initial + re-run after cart re-renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInjection);
  } else {
    runInjection();
  }
  document.addEventListener('cart-drawer:refreshed', runInjection);
  let guardTimer;
  document.addEventListener('cart:change', () => {
    // Some cart integrations emit intermediate cart:change payloads while a multi-item
    // bundle is still settling. Debounce and validate against Shopify's authoritative cart.
    clearTimeout(guardTimer);
    guardTimer = setTimeout(() => {
      fetch('/cart.js').then((r) => r.json()).then(guardTampering);
    }, 300);
    // headers re-injected after DOM settles
    setTimeout(runInjection, 50);
  });
})();
